<template>
	<div>
		<login-after-head></login-after-head>

		<head-nav-bar></head-nav-bar>

		<div class="container">

			<!-- mbx -->
			<div class="mbx-row  fc">
				<div class="container-left">
					<router-link to="index">首页</router-link>
					<i class="icon-arrow-right4 magr12l8"></i>
          <router-link :to="{path:'/list',query:{cate1Id:skuDetail.cateTitleTopId,cate2Id:skuDetail.cateTitleOneId}}">{{ skuDetail.cateTitleOne }}</router-link>
					<span><i class="icon-arrow-right4 magr12l8"></i></span>
          <router-link :to="{path:'/list',query:{cate2Id:skuDetail.cateTitleOneId,cate3Id:skuDetail.cateTitleTwoId}}">{{ skuDetail.cateTitleTwo }}</router-link>
					<span>
            <i class="icon-arrow-right4 magr12l8"></i>
          </span>
          <router-link :to="selectionLink">{{ skuDetail.cateTitleThree }}</router-link>
						<span><i class="icon-arrow-right4 magr12l8"></i></span>
				</div>
			</div>

			<!-- 主图 -->
			<div id="gdshow" class="new-item flex">
				<!-- 主图 -->
				<div class="left">
					<zhutu v-if="sliderImages && sliderImages.length>0" :imgsData="sliderImages" ></zhutu>
          			<img v-else class="img"  src="../assets/noll.png" style="width: 100%;"/>
				</div>
				<div class="main">
					<div class="title">
						<div class="title-text">
							<h1 class="" v-if="skuDetail.product">{{ skuDetail.product.storeName }}</h1>
							<h1 class="" v-else></h1>
							<h5 nstyle="color: black" v-if="this.skuDetail.productAttrValue">
            				  {{this.skuDetail.productAttrValue.skuName}}
<!--								<span class="p-detail ">长：0cm</span>-->
<!--								<span class="p-detail ">宽：0cm</span>-->
<!--								<span class="p-detail ">高：0cm</span>-->
							</h5>
							<h5 nstyle="color: black" v-else></h5>
							<h5 nstyle="color: black" v-if="this.skuDetail.productAttrValue" >产品编码：{{this.skuDetail.productAttrValue.unique}}</h5>
						</div>
					</div>
					<div class="price">
						<dl class="first-dl">
							<dt>价格</dt>
							<dd>
								<div class="money">
									 <span class="num" v-if="skuDetail.product.unpriced ==1">
										 <span class="money-img">￥</span>
										 价格面议
									 </span>
									 <span class="num" v-else>
										 <span class="money-img">￥</span>
										 {{skuDetail.productAttrValue.price}}
									 </span>
								</div>
							</dd>
						</dl>
					</div>
					<div class="choose-packing-method">
					  <div class="component-table">
					    <div class="portlet-body table-responsive">
					      <table border="0" cellspacing="0" cellpadding="0"  class="table-bordered table-striped table-condensed flip-content">
					        <thead>
					          <tr>
					            <th class="width85 text-left pdL10"> <span class="table-title-word ">装箱数</span> </th>
<!--					            <th class="width85"> <span class="table-title-word ">盒装数</span> </th>-->
<!--					            <th class="stock"> <span class="table-title-word ">库存</span> </th>-->
					            <th class="stockAttr"> <span class="table-title-word ">属性</span> </th>
<!--					            <th class="daohuo"> <span class="table-title-word ">到货周期</span> </th>-->
					            <th class="width80"> <span class="table-title-word ">含税面价(元)</span> </th>
					            <th class="width80"> <span class="table-title-word ">折扣价(元)</span> </th>
					            <th class="width150"> <span class="table-title-word ">购买数量</span> </th>
					            <th width="110"> <span class="table-title-word ">总量</span> </th>
					            <th class="width105"> <span class="table-title-word ">金额(元)</span> </th>
					          </tr>
					        </thead>
					        <tbody>
					          <tr>
					            <td class="width85">
					              <span class="">{{ skuDetail.productAttrValue.packageQuantity }}</span>
					            </td>
<!--					            <td class="width85"><span class="">1</span></td>-->
<!--					            <td class="stock"><span class="">{{skuDetail.productAttrValue.stock}}</span></td>-->
					            <td class="stockAttr">
					            	<span>{{skuDetail.productAttrValue.stockType}}</span>
					            </td>
<!--					            <td class="daohuo"><span class=""> - </span></td>-->
					            <td class="width80" >
									<span class="" v-if="skuDetail.product.unpriced ==1">面议</span>
									<span class="" v-else>{{skuDetail.productAttrValue.otPrice}}</span>
								</td>
					            <td class="width80">
									<span class="" v-if="skuDetail.product.unpriced ==1">面议</span>
									<span class="" v-else>{{skuDetail.productAttrValue.price}}</span>
								</td>
					            <td class="width150">
					            	<div class="add-numbox">
					                    <button type="button"   @click="skuDetail.productAttrValue.cartNum<=0?0:skuDetail.productAttrValue.cartNum--" >
					                        <i class="common-icons common-icons-reduceNum"></i>
					                     </button>
					                    <input v-model="skuDetail.productAttrValue.cartNum" maxlength="5" oninput="if(value<0)value=0"  >
					                    <button type="button" @click="skuDetail.productAttrValue.cartNum++"><i class="common-icons common-icons-addNum"  ></i></button>
					             	</div>
					             </td>
					            <td width="110"><span class="">{{ skuDetail.productAttrValue.cartNum }}</span></td>
					            <td class="width105">
									<span class="" v-if="skuDetail.product.unpriced ==1">面议</span>
									<span class=""  v-else>{{ (skuDetail.productAttrValue.cartNum * skuDetail.productAttrValue.price).toFixed(2)}}</span>
								</td>
					          </tr>
					        </tbody>
					      </table>
					    </div>

					    <div class="portlet-bottom" >
					      <label class="total-num ">数量总计:<span class="disIB f16 ">{{ skuDetail.productAttrValue.cartNum }}</span></label>
					      <label class="total-amount">总金额:
							<span class="disIB f16 red bold " v-if="skuDetail.product.unpriced ==1">价格面议</span>
							<span class="disIB f16 red bold " v-else>￥{{(skuDetail.productAttrValue.cartNum * skuDetail.productAttrValue.price).toFixed(2) }}</span>
						</label>
					    </div>
					  </div>
					</div>

					<div class="buy buy-outer fcc" v-if="skuDetail.product.unpriced ==1">



					    <div  class="buy buy-inner fcc" style="margin-left: 625px;">
<!--					      <a href="javascript:void(0)" class="btn-none btn addCart mgL10 car-color"  >立即购买</a>-->
					      <a href="javascript:void(0)" class="btn addCart mgL0 btn-none" @click="addCartClick" >加入购物车</a>
					      <a class="mgR10">
					      <div class="options-btn" v-if="false">
					        <input type="button" value="加入报价单">
					       </div>
					      </a>
<!--					      <span class="favorate-op icon-favorate "><i class="favorite-icon"></i> 收藏 </span>-->

						  <!-- <span class="favorate-op icon-favorated "><i class="favorite-icon"></i> 已收藏 </span> -->

					    </div>


					</div>

				</div>
			</div>

			<!-- 商品相关(详细) -->

			<div id="related">
				<div class="recommend-goods">
					<!-- 热销商品 -->
					<div class="related-box">
						<div class="related-box-inner">
							<div class="guess">
								<span class="title ">热销商品</span>
							</div>
							<div>
								<side-item :data="hotList"></side-item>
							</div>
						</div>
					</div>
					<!-- 详情 -->
					<div class="related-right" >
						<ul class="tab-titles">
							<li class="" :class="{active:tabIndex==1}" @click="tabIndex=1">
								商品介绍
							</li>
							<li class="" :class="{active:tabIndex==2}" @click="tabIndex=2">
								商品参数
							</li>
							<li class="" :class="{active:tabIndex==3}" @click="tabIndex=3">
								产品样本
							</li>
							<li class="" :class="{active:tabIndex==4}" @click="tabIndex=4">
								检测报告
							</li>
							<li class="" :class="{active:tabIndex==5}" @click="tabIndex=5">
								认证证书
							</li>
						</ul>
						<div class="tab-contents" ref="manualList">
							<div id="introduce" class="content txtcenter" :class="{active:tabIndex==1}" v-if="skuDetail.product">
								<div class="content-inner" v-html="skuDetail.product.description"></div>
							</div>
							<div id="introduce" class="content txtcenter" :class="{active:tabIndex==2}" v-if="skuDetail.product">
								<div class="content-inner" v-html="skuDetail.product.commodityParameters"></div>
							</div>
							<div id="introduce"  class="content txtcenter" :class="{active:tabIndex==3}" v-if="skuDetail.testProductList">
								<div class="component-table">
									<div class="portlet-body table-responsive">
										<table border="0" cellspacing="20" cellpadding="0"  class="table-bordered table-striped table-condensed flip-content">
											<thead>
											<tr>
												<th class="width250"> <span class="table-title-word ">文件名</span> </th>
												<th class="width150"> <span class="table-title-word ">文件类型</span> </th>
												<th class="width150"> <span class="table-title-word ">文件大小</span> </th>
												<th class="width150"> <span class="table-title-word ">查看</span> </th>
												<th class="width150"> <span class="table-title-word ">下载</span> </th>
											</tr>
											</thead>
											<tbody>
												<tr  v-for="(item,index) in skuDetail.testProductList">
													<td class="width250">
													<span class="">{{ item.fileName }}</span>
													</td>
													<td class="width150">
														<span>{{item.extension}}</span>
													</td>
													<td class="width150">
														<span>{{item.size}}</span>
													</td>
													<td class="width150">
														<div class="btn"> 
															<button class="btn"  @click="lookPdf(item.filePath,item.fileName)">查看文件</button>
														</div>
													</td>
													<td class="width150">
														<div class="btn"> 
															<button class="btn" @click="downloadPdf(item.filePath,item.fileName)">下载文件</button>
														</div>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>							
								
								<!-- <div class="content-inner" v-html="skuDetail.product.testProduct"></div> -->
							</div>
							<div id="introduce" class="content txtcenter" :class="{active:tabIndex==4}" v-if="skuDetail.testReportList">
								<div class="portlet-body table-responsive">
									<table border="0" cellspacing="20" cellpadding="0"  class="table-bordered table-striped table-condensed flip-content">
										<thead>
										<tr>
											<th class="width250"> <span class="table-title-word ">文件名</span> </th>
											<th class="width150"> <span class="table-title-word ">文件类型</span> </th>
											<th class="width150"> <span class="table-title-word ">文件大小</span> </th>
											<th class="width150"> <span class="table-title-word ">查看</span> </th>
											<th class="width150"> <span class="table-title-word ">下载</span> </th>
										</tr>
										</thead>
										<tbody>
											<tr  v-for="(item,index) in skuDetail.testReportList">
												<td class="width250">
													<span class="">{{ item.fileName }}</span>
												</td>
												<td class="width150">
													<span>{{item.extension}}</span>
												</td>
												<td class="width150">
													<span>{{item.size}}</span>
												</td>
												<td class="width150">
													<div class="btn"> 
														<button class="btn" @click="lookPdf(item.filePath,item.fileName)">查看文件</button>
													</div>
												</td>
												<td class="width150">
													<div class="btn"> 
														<button class="btn" @click="downloadPdf(item.filePath,item.fileName)">下载文件</button>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<!-- <a href="{{ skuDetail.product.testReport }}" class="" download="{{ skuDetail.product.name }}检测报告">
									<span class="title ">{{ skuDetail.product.testReport }}</span>								
								</a> -->
								<!-- <div class="content-inner" v-html="skuDetail.product.testReport"></div> -->
							</div>
							<div id="introduce" class="content txtcenter" :class="{active:tabIndex==5}" v-if="skuDetail.certificateList">
								<div class="portlet-body table-responsive">
									<table border="0" cellspacing="20" cellpadding="0"  class="table-bordered table-striped table-condensed flip-content">
										<thead>
										<tr>
											<th class="width250"> <span class="table-title-word ">文件名</span> </th>
											<th class="width150"> <span class="table-title-word ">文件类型</span> </th>
											<th class="width150"> <span class="table-title-word ">文件大小</span> </th>
											<th class="width150"> <span class="table-title-word ">查看</span> </th>
											<th class="width150"> <span class="table-title-word ">下载</span> </th>
										</tr>
										</thead>
										<tbody>
											<tr  v-for="(item,index) in skuDetail.certificateList">
												<td class="width250">
													<span class="">{{ item.fileName }}</span>
												</td>
												<td class="width150">
													<span>{{item.extension}}</span>
												</td>
												<td class="width150">
													<span>{{item.size}}</span>
												</td>
												<td class="width150">
													<div class="btn"> 
														<button class="btn" @click="lookPdf(item.filePath,item.fileName)">查看文件</button>
													</div>
												</td>
												<td class="width150">
													<div class="btn"> 
														<button class="btn" @click="downloadPdf(item.filePath,item.fileName)">下载文件</button>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>								
								<div class="content-inner">更多证书，请访问天正官网下载中心：
									<a href="https://www.tengen.com/Download.html" target="_blank" style="color: #57aca7;">
									https://www.tengen.com/Download.html							
								</a> 
								</div>
								<!-- <a href="{{ skuDetail.product.certificate }}" class="" download="{{ skuDetail.product.name }}认证证书">
									<span class="title ">{{ skuDetail.product.certificate }}</span>								
								</a> -->
								<!-- <div class="content-inner" v-html="skuDetail.product.certificate"></div> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<i-footer></i-footer>
		<fixed-right></fixed-right>
	</div>
</template>

<script>
	import {getSkuDetails,addCart,getHotDetails,getSkuDetailsVisit} from "@/api/home";
	import {getBaseToken} from "@/utils";
	import {getToken,getBlobFile} from '@/axios/cookies'
  export default {

		data() {
			return {
				tabIndex:1,
				hotList:[],
				skuDetail:{},
				unique: null,
				sliderImages: [],
				sliderImagesNoll: ['../assets/noll.png'],
			}
		},
		computed: {
			listLinkForSeries() {
				const pid = (this.skuDetail.productAttrValue && this.skuDetail.productAttrValue.productId) ||
					(this.skuDetail.product && this.skuDetail.product.id)
				if (pid) {
					return { path: '/list', query: { productId: pid } }
				}
				return {
					path: '/list',
					query: {
						cate2Id: this.skuDetail.cateTitleOneId,
						cate3Id: this.skuDetail.cateTitleTwoId
					}
				}
			},
			selectionLink() {
				const pid = (this.skuDetail.productAttrValue && this.skuDetail.productAttrValue.productId) ||
					(this.skuDetail.product && this.skuDetail.product.id)
				const name = this.skuDetail.cateTitleThree || ''
				if (pid) {
					return { path: '/selection', query: { categoryId: pid, keyword: name } }
				}
				return {
					path: '/list',
					query: {
						cate2Id: this.skuDetail.cateTitleOneId,
						cate3Id: this.skuDetail.cateTitleTwoId
					}
				}
			}
		},
		mounted() {
			console.log('商品详情页接收的参数，',this.$route.query.unique)
			this.unique = this.$route.query.unique			
			let token = getToken();
			if(!token){
					getBaseToken().then(res=>{
						this.querySkuDetailsVisit(this.unique);
					})
			}else{
				let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
               //console.log("detail userInfo.uid",userInfo);
               if (userInfo && userInfo.name){
					this.querySkuDetails(this.unique);
			   }else{
					this.querySkuDetailsVisit(this.unique);
			   }
			}
			
			this.queryHotList();

			if(this.$route.query.tabIndex){
				this.tabIndex = this.$route.query.tabIndex
				if(this.$route.query.tabIndex == 3){
					setTimeout(()=>{
						this.$refs.manualList.scrollIntoView({ 
							block: 'end',
							behavior: 'smooth' 
						});
					},1000);

				}
			}
			
		},
		methods: {
     	 queryHotList(){
			getHotDetails().then(res=>{
			this.hotList = res.data;
			})
      },
      addCartClick(){
        console.log()
        if (this.skuDetail.productAttrValue.cartNum>0){
          let addCartPamars={
            uniqueId:this.skuDetail.productAttrValue.unique,
            cartNum:this.skuDetail.productAttrValue.cartNum,
            productId:this.skuDetail.productAttrValue.productId,
          }
          console.log('加入购物车',addCartPamars)
          addCart(addCartPamars).then(res=>{
            console.log('添加购物车成功结果',res)
            this.skuDetail.productAttrValue.cartNum=0
            this.$message.success('添加成功')
            this.$router.push({
              path: '/cart'
            })
            this.$forceUpdate()
          })
        }
      },
	  lookPdf(url,index) {
		console.log('lookPdf url',url);
		window.open('https://preview.tengen.com.cn:8443/view/url?url=' + encodeURIComponent(url), '_blank');
	  }
	  ,
	//   downloadPdf2(url, filename) {		
	// 	var url = url;
	// 	var xhr = new XMLHttpRequest();
	// 	xhr.open('GET', url, true); // 异步
	// 	xhr.responseType = 'blob'; // blob 类型
	// 	xhr.onload = function () {
	// 		if (xhr.status !== 200) {
	// 			alert('下载异常！');
	// 			return;
	// 		}
	// 		if (window.navigator.msSaveOrOpenBlob) {
	// 			// IE
	// 			navigator.msSaveBlob(xhr.response, filename);
	// 		} else {
	// 			var newUrl = window.URL.createObjectURL(xhr.response);
	// 			var a = document.createElement('a');
	// 			a.setAttribute('href', newUrl);
	// 			a.setAttribute('target', '_blank');
	// 			a.setAttribute('download', filename + '.pdf'); // 自定义文件名（有效）
	// 			document.body.appendChild(a);
	// 			a.click();
	// 			document.body.removeChild(a);

	// 		}
	// 	};
	// 	xhr.send();
	//   },

	  downloadPdf(urls, fileName) {
		let aLink = document.createElement('a'); // 创建a标签
		aLink.href = urls+ '&response-content-type=application/octet-stream';//加后缀任何链接都会下载,而不是预览
		//aLink.download = fileName;
		aLink.setAttribute('target', '_blank');
		aLink.setAttribute('download', fileName + '.pdf'); // 自定义文件名（有效）
		console.log(aLink.download)
		document.body.appendChild(aLink);
		aLink.click();
		document.body.removeChild(aLink);
 		},

		//  downloadPdf1(urls, fileName) {
		// 	//下载
		// 	var x = new XMLHttpRequest();
		// 	x.open('GET', urls, true);
		// 	x.responseType = 'blob';
		// 	x.onload = function(e) {
		// 		var url = window.URL.createObjectURL(x.response);
		// 		const link = document.createElement('a');
		// 		link.target = '_blank';
		// 		link.href = url;
		// 		link.download = fileName;
		// 		document.body.appendChild(link);
		// 		link.click();
		// 		document.body.removeChild(link);
		// 	};
		// 	x.send();
		// },
	//   downloadPdf(file,fileName) {
	// 	const blob = new Blob([file], { type: 'application/pdf' })
	// 	//const link = document.createElement('a')
	// 	//link.href = window.URL.createObjectURL(blob)
	// 	//let url = window.URL.createObjectURL(new Blob([file]));
	// 	const url = window.URL.createObjectURL(blob);
	// 	const link = document.createElement('a');
	// 	link.style.display = 'none';
	// 	link.href = url;
	// 	link.setAttribute('download', fileName);
	// 	document.body.appendChild(link);
	// 	link.click();
	// 	document.body.removeChild(link); // 下载完成移除元素
	// 	window.URL.revokeObjectURL(url); // 释放掉blob对象		

		
	//   },
	  getProductDetail(id, type) {
      let params = {
        id: id
      }
      getDetail(params).then(res => {
			this.product = res.data
			if (type == '1') {
			this.fileList = res.data.certificateList;
			} else if (type == '2') {
			this.fileList = res.data.testReportList;
			} else if (type == '3') {
			this.fileList = res.data.testProductList;
			}
			console.log('文件列表：', this.fileList)
		});
	  },
	  querySkuDetailsVisit(unique){
        console.log('查询SKU详情',unique)
        let params = {
          unique: this.unique
        }
        getSkuDetailsVisit(params).then(res => {
          this.skuDetail = res.data
          console.log('SKU详情查询结果',this.skuDetail)
          this.sliderImages = []
          if(this.skuDetail && this.skuDetail.product && this.skuDetail.product.sliderImage){
            this.skuDetail.product.sliderImage.split(',').forEach(item => {
              this.sliderImages.push(item)
            })
          }
          if (this.skuDetail && this.skuDetail.productAttrValue){
            this.skuDetail.productAttrValue.cartNum = 1
          }
        })
      },
      querySkuDetails(unique){
        console.log('查询SKU详情',unique)
        let params = {
          unique: this.unique
        }
        getSkuDetails(params).then(res => {
          this.skuDetail = res.data
          console.log('SKU详情查询结果',this.skuDetail)
          this.sliderImages = []
          if(this.skuDetail && this.skuDetail.product && this.skuDetail.product.sliderImage){
            this.skuDetail.product.sliderImage.split(',').forEach(item => {
              this.sliderImages.push(item)
            })
          }
          if (this.skuDetail && this.skuDetail.productAttrValue){
            this.skuDetail.productAttrValue.cartNum = 1
          }
        })
      },
		},


	}
</script>

<style scoped lang="less">

</style>
